var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 18.9589C5.66706 18.9589 2.15039 15.4339 2.15039 11.1089C2.15039 9.55052 2.60872 8.04219 3.47539 6.74219C3.66706 6.45885 4.05872 6.37552 4.34206 6.56719C4.62539 6.75885 4.70872 7.15052 4.51706 7.43385C3.79206 8.51719 3.40872 9.79219 3.40872 11.1005C3.40872 14.7422 6.36706 17.7005 10.0087 17.7005C13.6504 17.7005 16.6087 14.7422 16.6087 11.1005C16.6087 7.45885 13.6421 4.50052 10.0004 4.50052C9.23372 4.50052 8.48372 4.60885 7.77539 4.82552C7.44206 4.92552 7.09206 4.74219 6.99206 4.40885C6.89206 4.07552 7.07539 3.72552 7.40872 3.62552C8.24206 3.37552 9.10872 3.24219 10.0004 3.24219C14.3337 3.24219 17.8504 6.76719 17.8504 11.0922C17.8504 15.4172 14.3337 18.9589 10.0004 18.9589Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55928 5.05811C6.41762 5.05811 6.26762 5.00811 6.15095 4.90811C5.88428 4.67477 5.85928 4.28311 6.08428 4.02477L8.49262 1.25811C8.71762 0.999775 9.11762 0.966442 9.37595 1.19978C9.63428 1.42478 9.65928 1.82478 9.43428 2.08311L7.02595 4.84144C6.90095 4.98311 6.72595 5.05811 6.55928 5.05811Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36697 7.11007C9.24197 7.11007 9.10864 7.0684 9.00031 6.9934L6.18364 4.93507C5.90864 4.73507 5.85031 4.3434 6.05031 4.0684C6.25031 3.78507 6.64197 3.72673 6.92531 3.92673L9.73364 5.97673C10.0086 6.17673 10.0753 6.5684 9.86697 6.85173C9.75031 7.02673 9.55864 7.11007 9.36697 7.11007Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.7a1fc499cdadb025a86115d63712586c.svg";
export { ForwardRef as ReactComponent };